import { Summary } from '@/modules/report/slice/betSummary';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { GetGameName, GetGameShoeRound } from '../../util';
import './SummaryGameRoundText.scss';

type SummaryGameRoundTextProps = {
    summary: Summary;
};
export const SummaryGameRoundText = (props: SummaryGameRoundTextProps) => {
    const { t } = useTranslation();

    const { GameType, Round, Shoes, HostID } = props.summary;

    const { i18n } = useTranslation();
    const languageDir = useMemo(() => {
        return i18n.dir(i18n.language);
    }, [i18n.language]);

    const gameName = useMemo(
        () => GetGameName(GameType, HostID, t),
        [GameType, HostID, i18n.language]
    );

    const shoeRound = useMemo(
        () => GetGameShoeRound(GameType, Round, Shoes),
        [GameType]
    );

    return (
        <div className={`summary-show-round-text-wrapper`}>
            {languageDir !== 'rtl' ? (
                <>
                    <span className="game-name">{gameName}</span>
                    <span className="shoe-round">{`\u00A0/\u00A0${shoeRound}`}</span>
                </>
            ) : (
                <>
                    <span className="shoe-round">{`${shoeRound}\u00A0/\u00A0`}</span>
                    <span className="game-name">{gameName}</span>
                </>
            )}
        </div>
    );
};
